import { Controller } from 'stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['category', 'tags', 'removal'];
  static values = { itemId: Number, reloadOnClose: Boolean };

  #saved = false;

  categoryTargetConnected(element) {
    $(element).selectize({
      placeholder: 'Type a new category or select one from the list…',
      persist: false,
      create(name, callback) {
        $.post('/item_categories/xhr_create', { name }).done((category) => {
          callback({ value: category.id, text: category.name });
        });
      },
    });
  }

  tagsTargetConnected(element) {
    const current = element.value
      ? element.value.split(',').map((tag) => ({ data: tag, value: tag }))
      : [];

    $(element).selectize({
      plugins: ['remove_button'],
      persist: false,
      createOnBlur: true,
      create: true,
      sortField: { field: 'text', direction: 'asc' },
      options: current.concat(JSON.parse(element.dataset.tags || '[]')),
      render: {
        item: (data, escape) => `<div class="field__tag-item">${escape(data.text)}</div>`,
      },
      load: (query, callback) => {
        if (!query.length) {
          callback();
          return;
        }

        $.get('/tags/xhr_selectize_tags', { q: query })
          .done(callback)
          .fail(() => callback());
      },
    });
  }

  categoryTargetDisconnected(element) {
    element.selectize?.destroy();
  }

  tagsTargetDisconnected(element) {
    element.selectize?.destroy();
  }

  removalTargetConnected(element) {
    $(element).on('ajax:success.item-details', () => this.#removed(element));
  }

  removalTargetDisconnected(element) {
    $(element).off('ajax:success.item-details');
  }

  dropEmptyFiles({ formData }) {
    const emptyFileKeys = [...formData.entries()]
      .filter(([, value]) => value instanceof File && value.size === 0 && !value.name)
      .map(([key]) => key);

    emptyFileKeys.forEach((key) => formData.delete(key));
  }

  submitted({ detail }) {
    if (!detail.success) {
      return;
    }

    this.#saved = true;
    this.dispatch('updated', {
      prefix: 'shoppable',
      target: document,
      detail: { kind: 'item', id: this.itemIdValue || null },
    });
  }

  closed() {
    if (this.reloadOnCloseValue && !this.#saved) {
      window.location.reload();
    }
  }

  #removed(element) {
    const fields = element.closest('.items--details-fields');

    if ($(this.element).find('.items--details-fields:visible').length > 1) {
      $(fields).slideUp(() => fields.remove());
    } else {
      this.element.closest('dialog').close();
    }
  }
}
